export const SET_LOADING_BASEDATA = "SET_LOADING_BASEDATA";
export const SET_FAILURE_BASEDATA = "SET_FAILURE_BASEDATA";
export const SET_SUCCESS_BASEDATA = "SET_SUCCESS_BASEDATA";
export const SET_BAZAR_BASEDATA = "SET_BAZAR_BASEDATA";
